import React from "react";
import { formatNumberFixed } from "../../utils/helper";

interface ContentCellNumberProps {
  value?: number | null;
}

const ContentCellNumber: React.FC<ContentCellNumberProps> = ({ value }) => {
  if (value == null) return <span></span>;
  return <span style={{ textAlign: "right" }}>{formatNumberFixed(value)}</span>;
};

export default ContentCellNumber;
